import { createAction, props } from '@ngrx/store';

import type { HuntingProductMedia } from '../../models/hunting-product-media.model';
import { prefixed } from '../../utils/factory.utils';

const huntingProductSync = prefixed('[Hunting Product Sync]');

export const HuntingProductSyncActions = {
  syncStarted: createAction(huntingProductSync('Sync started'), props<{ serial: string; deviceId: string }>()),

  syncDiscoverySucceeded: createAction(huntingProductSync('Sync discovery succeeded'), props<{ serial: string; deviceId: string; pendingCount: number }>()),
  syncDiscoveryFailed: createAction(huntingProductSync('Sync discovery failed'), props<{ error: string }>()),

  mediaItemSynced: createAction(huntingProductSync('Media item synced'), props<{ media: HuntingProductMedia }>()),

  syncSucceeded: createAction(huntingProductSync('Sync succeeded'), props<{ syncedCount: number }>()),
  syncFailed: createAction(huntingProductSync('Sync failed'), props<{ error: string }>()),
};
